import React from 'react';
import './CurrentOrder.css';

const CurrentOrder = ({ cartItems, onTrackOrder }) => {
  const calculateTotal = () => {
    return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  return (
    <div className="current-order-card">
      <h3>🛒 Su pedido actual</h3>
      <div className="order-status">
        <div className="status-indicator"></div>
        <span className="status-text">Listo para pagar</span>
      </div>
      <div className="order-details">
        {cartItems.map(item => (
          <div key={item.cartId} className="order-item">
            <span className="item-name">{item.quantity}x {item.name}</span>
            <span className="item-price">${(item.price * item.quantity).toFixed(2)}</span>
          </div>
        ))}
        <div className="order-total">
          <span>Total:</span>
          <span className="total-amount">${calculateTotal().toFixed(2)}</span>
        </div>
      </div>
      <button className="track-order-btn" onClick={onTrackOrder}>
        Seguimiento pedido y pago
      </button>
    </div>
  );
};

export default CurrentOrder;